var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.reportsAvailable.length > 0
    ? _c(
        "CompassFeatureBanner",
        {
          staticClass: "report-banner",
          attrs: {
            illustration: "/ressources/logged/img/illustrations/reporting.svg",
            title: _vm.$t.__("report.ReportBanner.try_new_reports")
          }
        },
        [
          _c(
            "div",
            { staticClass: "report-banner__buttons" },
            _vm._l(_vm.reportsAvailablesSorted, function(report) {
              return _c(
                "div",
                {
                  key: "report-" + report.code,
                  staticClass: "report-banner__buttons-button"
                },
                [
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__(report.keyName),
                      type: "tertiary-contrast"
                    },
                    on: {
                      click: function($event) {
                        report.upsell
                          ? _vm.openFeatureModal(report.code)
                          : _vm.redirectToNewReport(report.id)
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        report.upsell
                          ? {
                              key: "prefix",
                              fn: function() {
                                return [
                                  _c("CompassFeatureBadge", {
                                    attrs: {
                                      size: "small",
                                      variant: "upsell",
                                      isInteractive: false
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          : null
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            }),
            0
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }